import styled from "styled-components";

export const MicroHeader = styled.h5`
  font-family: ${({ theme }) => theme.fonts.microHeader.family};
  font-size: ${({ theme }) => theme.fonts.microHeader.fontSize};
  line-height: ${({ theme }) => theme.fonts.microHeader.lineHeight};
  font-weight: ${({ theme }) => theme.fonts.microHeader.fontWeight};
  letter-spacing: ${({ theme }) => theme.fonts.microHeader.letterSpacing};
  max-width: ${({ theme }) => theme.copyMaxWidth};
  color: ${({ theme }) => theme.colors.typographyDefault};
  margin: 0;
`;
